// import React, { useEffect, useRef } from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import RecommendationCard from "../../../agent/components/RecommendationCard/RecommendationCard";
// import MetricsCard from "../../../agent/components/MetricsCard/MetricsCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchRecommendationsStart } from "../../../redux/slices/agentHomeSlice";

// const DownloadPDF = ({
//   dataAccessor,
//   cardHeader,
//   triggerDownload,
//   setTriggerDownload,
// }) => {
//   const dispatch = useDispatch();

//   const recommendations = useSelector(
//     (state) => state.agentHome.recommendations?.[dataAccessor] || []
//   );
//   const pdfRef = useRef([]);

//   useEffect(() => {
//     dispatch(fetchRecommendationsStart());
//   }, [dispatch]);

//   useEffect(() => {
//     if (triggerDownload && recommendations.length > 0) {
//       const timer = setTimeout(async () => {
//         const pdf = new jsPDF("p", "mm", "a4");
//         const pdfWidth = pdf.internal.pageSize.getWidth();

//         for (let i = 0; i < recommendations.length; i++) {
//           const element = pdfRef.current[i];
//           if (element) {
//             const canvas = await html2canvas(element, {
//               useCORS: true,
//               allowTaint: true,
//               scale: 2,
//             });
//             const imgData = canvas.toDataURL("image/png");
//             const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
//             if (i > 0) pdf.addPage();
//             pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

//             // ✨ Add pagination in center bottom
//             const pageNumText = `${i + 1} of ${recommendations.length}`;
//             pdf.setFont("helvetica", "normal");
//             pdf.setFontSize(10);
//             const textWidth = pdf.getTextWidth(pageNumText);
//             const centerX = (pdfWidth - textWidth) / 2;
//             const bottomY = pdfHeight - 10; // 10mm from bottom edge
//             pdf.text(pageNumText, centerX, bottomY);
//           }
//         }

//         pdf.save(`${cardHeader}_Insights.pdf`);
//         setTriggerDownload(false);
//       }, 800);

//       return () => clearTimeout(timer);
//     }
//   }, [triggerDownload, recommendations, cardHeader, setTriggerDownload]);

//   return (
//     <div
//       style={{
//         position: "absolute",
//         left: "-9999px",
//         top: 0,
//         visibility: triggerDownload ? "visible" : "hidden",
//       }}
//     >
//       {recommendations.map((rec, index) => (
//         <div
//           key={index}
//           ref={(el) => (pdfRef.current[index] = el)}
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             gap: "20px",
//             padding: "20px",
//             width: "800px",
//             backgroundColor: "white",
//             marginBottom: "40px",
//           }}
//         >
//           <div style={{ flex: 1 }}>
//             <RecommendationCard
//               recommendationCardTitle={cardHeader}
//               recommendation={rec}
//               currentPage={index + 1}
//               totalPages={recommendations.length}
//             />
//           </div>
//           <div style={{ flex: 1 }}>
//             <MetricsCard
//               metrics={rec}
//               dataAccessor={dataAccessor}
//               currentPage={index + 1}
//               recommendationCardTitle={cardHeader}
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default DownloadPDF;

// import React, { useEffect, useRef } from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import RecommendationCard from "../../../agent/components/RecommendationCard/RecommendationCard";
// import MetricsCard from "../../../agent/components/MetricsCard/MetricsCard";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchRecommendationsStart } from "../../../redux/slices/agentHomeSlice";

// const DownloadPDF = ({
//   dataAccessor,
//   cardHeader,
//   triggerDownload,
//   setTriggerDownload,
// }) => {
//   const dispatch = useDispatch();

//   const recommendations = useSelector(
//     (state) => state.agentHome.recommendations?.[dataAccessor] || []
//   );
//   const pdfRef = useRef([]);

//   useEffect(() => {
//     dispatch(fetchRecommendationsStart());
//   }, [dispatch]);

//   useEffect(() => {
//     if (triggerDownload && recommendations.length > 0) {
//       const timer = setTimeout(async () => {
//         const pdf = new jsPDF("p", "mm", "a4");
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = pdf.internal.pageSize.getHeight();

//         for (let i = 0; i < recommendations.length; i++) {
//           const element = pdfRef.current[i];
//           if (element) {
//             const canvas = await html2canvas(element, {
//               useCORS: true,
//               allowTaint: true,
//               scale: 2,
//             });
//             const imgData = canvas.toDataURL("image/png");
//             const imgHeight = (canvas.height * pdfWidth) / canvas.width;

//             if (i > 0) pdf.addPage();
//             pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, imgHeight);

//             // Add pagination at the bottom center
//             const pageNumText = `${i + 1} of ${recommendations.length}`;
//             pdf.setFont("helvetica", "normal");
//             pdf.setFontSize(10);
//             const textWidth = pdf.getTextWidth(pageNumText);
//             const xPos = (pdfWidth - textWidth) / 2;
//             pdf.text(pageNumText, xPos, pdfHeight - 10); // 10mm from bottom
//           }
//         }

//         pdf.save(`${cardHeader}_Insights.pdf`);
//         setTriggerDownload(false);
//       }, 800);

//       return () => clearTimeout(timer);
//     }
//   }, [triggerDownload, recommendations, cardHeader, setTriggerDownload]);

//   return (
//     <div
//       style={{
//         position: "absolute",
//         left: "-9999px",
//         top: 0,
//         visibility: triggerDownload ? "visible" : "hidden",
//       }}
//     >
//       {recommendations.map((rec, index) => (
//         <div
//           key={index}
//           ref={(el) => (pdfRef.current[index] = el)}
//           style={{
//             display: "flex",
//             flexDirection: "row",
//             gap: "20px",
//             padding: "20px",
//             width: "800px",
//             backgroundColor: "white",
//             marginBottom: "40px",
//           }}
//         >
//           <div style={{ flex: 1 }}>
//             <RecommendationCard
//               recommendationCardTitle={cardHeader}
//               recommendation={rec}
//               currentPage={index + 1}
//               totalPages={recommendations.length}
//             />
//           </div>
//           <div style={{ flex: 1 }}>
//             <MetricsCard
//               metrics={rec}
//               dataAccessor={dataAccessor}
//               currentPage={index + 1}
//               recommendationCardTitle={cardHeader}
//             />
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default DownloadPDF;
import React, { useEffect, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { useDispatch, useSelector } from "react-redux";
import { fetchRecommendationsStart } from "../../../redux/slices/agentHomeSlice";
import "./DownloadPDF.css";
import UIConfig from "../../constants/UIConfig";
import magicHealthLogo from "../../../assets/images/magicHealthLogo.png";

const DownloadPDF = ({
  dataAccessor,
  cardHeader,
  triggerDownload,
  setTriggerDownload,
}) => {
  const dispatch = useDispatch();
  const recommendations = useSelector(
    (state) => state.agentHome.recommendations?.[dataAccessor] || []
  );

  const pdfRef = useRef([]);

  useEffect(() => {
    dispatch(fetchRecommendationsStart());
  }, [dispatch]);

  useEffect(() => {
    if (triggerDownload && recommendations.length > 0) {
      const generatePDF = async () => {
        const pdf = new jsPDF("p", "mm", "a4", true);
        const pdfWidth = pdf.internal.pageSize.getWidth();

        for (let i = 0; i < recommendations.length; i++) {
          const element = pdfRef.current[i];
          if (!element) continue;

          if (i > 0) pdf.addPage();

          const canvas = await html2canvas(element, {
            useCORS: true,
            scale: 2, // 2 is optimal for balance between quality and file size
            logging: false,
          });
          const imgData = canvas.toDataURL("image/jpeg", 0.95);
          const imgHeight = (canvas.height * pdfWidth) / canvas.width;

          pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight, undefined, 'FAST');
        }

        pdf.save(`${cardHeader}_Report.pdf`);
        setTriggerDownload(false);
      };

      setTimeout(generatePDF, 800);
    }
  }, [triggerDownload, recommendations, cardHeader, setTriggerDownload]);

  // Format a date string using the centralized EST timezone from UIConfig
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-US", {
      timeZone: UIConfig.branding.timeZone || "America/New_York",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
  };

  // Today's date rendered in the PDF header — always in EST
  const todayDisplay = new Date().toLocaleDateString("en-US", {
    timeZone: UIConfig.branding.timeZone || "America/New_York",
    month: "2-digit",
    day: "2-digit",
    year: "numeric",
  });

  return (
    <div
      style={{
        position: "absolute",
        left: "-9999px",
        top: 0,
        visibility: triggerDownload ? "visible" : "hidden",
      }}
    >
      {recommendations.map((rec, index) => (
        <div
          key={index}
          ref={(el) => (pdfRef.current[index] = el)}
          style={{
            width: "794px", // Standard A4 width at 96 DPI
            height: "1123px",
            backgroundColor: "white",
            position: "relative",
            fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
            color: "#444",
            display: "flex",
            flexDirection: "column"
          }}
        >
          {/* 1. HEADER SECTION */}
          <div style={{
            height: "70px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 35px",
            borderBottom: "1px solid #f0f0f0"
          }}>
            <img src={UIConfig.branding.logo} alt="Client Logo" style={{ height: "32px", width: "auto" }} />

            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <span style={{ fontSize: "11px", color: "#888", fontWeight: "500" }}>Powered by</span>
              <img src={magicHealthLogo} alt="Magic Health" style={{ height: "22px", width: "auto" }} />
              <div style={{ width: "1px", height: "20px", backgroundColor: "#ddd", margin: "0 10px" }} />
              <span style={{ fontSize: "12px", color: "#555", fontWeight: "600" }}>
                {todayDisplay}
              </span>
            </div>
          </div>

          {/* 2. BODY SECTION WITH SLIM SIDEBAR */}
          <div style={{ display: "flex", flex: 1, position: "relative" }}>

            {/* Slim Sidebar Accent */}
            <div style={{
              width: "12px",
              backgroundColor: "#1e3c72",
              height: "100%"
            }} />

            {/* Main Content Content */}
            <div style={{ flex: 1, padding: "35px 40px", display: "flex", gap: "40px" }}>

              {/* Left Column: Details */}
              <div style={{ flex: 1.8 }}>
                <h2 style={{
                  fontSize: "19px",
                  color: "#1e3c72",
                  marginBottom: "25px",
                  fontWeight: "700",
                  letterSpacing: "-0.3px"
                }}>
                  {cardHeader} Improvement Recommendation {index + 1}/{recommendations.length}
                </h2>

                <div style={{ marginBottom: "22px" }}>
                  <h4 style={{ fontSize: "14px", color: "#333", marginBottom: "6px", fontWeight: "600" }}>Opportunity:</h4>
                  <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.5" }} dangerouslySetInnerHTML={{ __html: rec?.opportunity }} />
                </div>

                <div style={{ marginBottom: "22px" }}>
                  <h4 style={{ fontSize: "14px", color: "#333", marginBottom: "6px", fontWeight: "600" }}>Recommendation:</h4>
                  <div style={{ fontSize: "13px", color: "#666", lineHeight: "1.6" }}>
                    <span style={{ fontWeight: "700", color: "#555" }}>Example: </span>
                    <span dangerouslySetInnerHTML={{ __html: rec?.recommendation }} />
                  </div>
                </div>

                {rec?.guidance && (
                  <div>
                    <h4 style={{ fontSize: "14px", color: "#333", marginBottom: "8px", fontWeight: "600" }}>Guidance:</h4>
                    <div style={{
                      fontSize: "13px",
                      color: "#666",
                      lineHeight: "1.7",
                      paddingLeft: "15px"
                    }}
                      dangerouslySetInnerHTML={{
                        __html: Object.values(rec.guidance)
                          .map((text, idx) => `<div style="margin-bottom: 4px;">${idx + 1}. ${text}</div>`)
                          .join(""),
                      }}
                    />
                  </div>
                )}
              </div>

              {/* Right Column: Mini Data Card */}
              <div style={{ flex: 1 }}>
                <div style={{
                  border: "1px solid #e8e8e8",
                  borderRadius: "6px",
                  padding: "18px",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.02)"
                }}>
                  {[
                    { label: "Date of first identification", value: formatDate(rec.CreatedOn) },
                    { label: "Total Affected Interactions", value: `${rec?.NoOfInteractionsaffected || 0}/${rec?.totalCalls || 100}` },
                    { label: "Total Escalations", value: `${rec?.NoOfEscalations || 0}/${rec?.totalCalls || 100}` },
                    { label: "Interactions Impacted (24h)", value: `${rec?.NoOfInteractionsAffectedIn24Hours || 0}/${rec?.totalCalls || 100}` }
                  ].map((item, idx) => (
                    <div key={idx} style={{ marginBottom: idx === 3 ? 0 : "18px" }}>
                      <div style={{ fontSize: "11px", color: "#999", fontWeight: "600", textTransform: "uppercase", marginBottom: "3px" }}>{item.label}</div>
                      <div style={{ fontSize: "13px", color: "#1e3c72", fontWeight: "700" }}>{item.value}</div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* 3. FOOTER SECTION */}
          <div style={{
            height: "40px",
            padding: "0 40px 20px 52px",
            display: "flex",
            justifyContent: "center",
            fontSize: "11px",
            color: "#bbb"
          }}>
            {index + 1} of {recommendations.length}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DownloadPDF;